// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsAppButton_whatsappButton__PFhLv","icon":"WhatsAppButton_icon__iyMY+"};